<!-- this component is basically the same that is in the Astro project (astro\src\components\storyblok-components\PostCard.astro). When migrating the Header Menu to Astro, we can remove this component. -->

<script>
import ChevronRight from "./Icons/ChevronRight.vue";

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  components: {
    ChevronRight,
  },
  computed: {
    title() {
      return this.post.name;
    },
    description() {
      return this.post.content.title;
    },
    iconSrc() {
      const isInternalIcon =
        this.post.content.icon.filename.includes("storyblok.com");
      const iconSrc = isInternalIcon
        ? `${this.post.content.icon.filename}/m/200x200/smart`
        : this.post.content.icon.filename;
      return iconSrc;
    },
    iconAlt() {
      return this.post.content.icon.alt || `Icon for "${this.title}"`;
    },
    postUrl() {
      return `/${this.post.full_slug}`;
    },
    carouselItemHeadingId() {
      return `carousel-item-${this.post.id}__heading`;
    },
  },
};
</script>

<template>
  <a class="h-post-card" :href="postUrl">
    <div class="content-container">
      <div class="icon-container">
        <img
          class="post-icon"
          :src="iconSrc"
          :alt="iconAlt"
          width="50"
          height="50"
        />
      </div>

      <div class="content">
        <span class="card-title" :id="carouselItemHeadingId">{{ title }}</span>
        <p>{{ description }}</p>
      </div>
    </div>

    <div class="post-card-footer">
      <span class="cta-link">Zum Beitrag</span>

      <i class="chevron-icon">
        <ChevronRight width="24" height="24" />
      </i>
    </div>
  </a>
</template>

<style scoped lang="scss">
.h-post-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 11px;
  width: 100%;
  max-width: 440px;
  cursor: pointer;
  text-decoration: none;

  .content-container {
    display: flex;
    flex-direction: row;
    position: relative;
    height: 100%;
    width: 100%;
    gap: 15px;
  }

  .icon-container {
    height: 100%;
    min-height: 70px;
    max-width: 100px;
    background-color: #eeee;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    padding: 10px;
  }

  .post-icon {
    height: 40px;
    width: auto;
    object-fit: cover;
  }

  .content {
    min-height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 3px;

    .card-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
      color: #000000;
      margin-bottom: unset !important;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
      hyphens: auto;
      word-wrap: break-word;
      max-width: 100%;
    }

    p {
      font-size: 14px;
      line-height: 1.5;
      color: #000000;
      margin-bottom: unset !important;
    }
  }

  .post-card-footer {
    display: flex;
    flex-direction: column;
    background-color: unset !important;
    padding-left: unset !important;
    padding-right: unset !important;
    width: 100%;
  }

  .chevron-icon {
    display: none;

    svg {
      vertical-align: middle;
    }
  }

  a {
    text-decoration: none;
  }

  .cta-link {
    padding: 10px 13px;
    background-color: #35887e;
    border-radius: 5px;
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
    color: #ffffff !important;
    border: none;
    text-decoration: none;

    &:hover {
      background-color: #23615a !important;
      color: #ffffff !important;
    }
  }
}

@media (min-width: 421px) {
  .h-post-card {
    .post-icon {
      height: 48px;
    }
  }
}

@media (min-width: 768px) {
  .h-post-card {
    flex-direction: row;
    align-items: center;
    padding: 8px 13px 8px 8px;
    gap: 10px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    transition: box-shadow 0.1s ease-in-out;

    &:hover {
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.3);
    }

    .icon-container {
      min-height: 120px;
      max-width: 120px;
      padding: 15px;
    }

    .post-icon {
      height: 60px;
      width: auto;
    }

    .content-container {
      gap: 15px;
      align-items: center;
    }

    .content {
      min-height: 120px;

      .card-title {
        font-size: 18px;
        line-height: 27px;
        color: #393939;
      }

      p {
        font-size: 16px;
        color: #474747;
      }
    }

    .post-card-footer {
      width: unset;

      .cta-link {
        display: none;
        width: -moz-fit-content;
        width: fit-content;
        padding: 20px 30px;
        border-radius: 6px;
        font-size: 19px;
        line-height: 16px;
      }

      .chevron-icon {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
